var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.ShippingValidation = (function () {
  var usShippingField = '[data-shipping-country-code=\'US_CON\']';
  var shippingEnabledField = '[data-bind=\'shipping-enabled\']';
  var shippingMatrix = '[data-bind=\'product-shipping-fields\']';
  var shippingMatrixInputs = shippingMatrix + ' input';
  var localShippingCheckbox = '#product_shipping_local';
  var shippingRates = '[data-shipping-rate]';

  var shippingErrors = '.shipping-error';
  var shippingErrorSelectOne = '#shipping-choose';
  var shippingErrorMissingRate = '#shipping-rate-missing';

  function isShippingEnabled() {
    return $(shippingEnabledField).is(':checked');
  }

  function handleShippingSelect() {
    $(shippingEnabledField).change(function () {
      enableShippingFields();
      validateShippingOptionPresent();
      requireShippingFields();
    });
    $(localShippingCheckbox).change(function (e) {
      validateShippingOptionPresent();
    });
  }

  function bindShippingRateChange() {
    $(shippingRates).blur(function () {
      validateUSShippingRatePresent();
    });
  }

  function enableShippingFields() {
    $(shippingMatrixInputs).prop('disabled', !isShippingEnabled());
  }

  function requireShippingFields() {
    if (isShippingEnabled()) {
      $(usShippingField).prop('required', true);
    } else {
      $(usShippingField).prop('required', false);
    }
  }

  function setShippingOnLoad() {
    enableShippingFields();
    showHideShippingMatrix();
    requireShippingFields();
  }

  function showHideShippingMatrix() {
    var shippingMatrixElement = $(shippingMatrix);
    if (isShippingEnabled()) {
      shippingMatrixElement.show();
    } else {
      shippingMatrixElement.hide();
    }
  }

  function isLocalPickupEnabled() {
    return $(localShippingCheckbox).is(':checked');
  }

  function isUnitedStatesRatePresent() {
    // https://sentry.io/reverb-llc/discovery-ui/issues/670392002
    // If val returns undefined, the field is not present.
    if (!$(usShippingField).val()) {
      return false;
    }

    return ($(usShippingField).val().length != 0);
  }

  function unrequireShippingFields() {
    $(shippingMatrixInputs).removeAttr('required');
  }

  function validateUSShippingRatePresent() {
    var valid = true;

    $(shippingErrorMissingRate).hide();
    $(usShippingField).removeClass('ui-state-error');

    if (isShippingEnabled() && !isUnitedStatesRatePresent()) {
      $(shippingErrorMissingRate).fadeIn();
      $(usShippingField).addClass('ui-state-error');
      valid = false;
    }

    return valid;
  }

  function validateShippingOptionPresent() {
    var valid = true;

    $(shippingErrorSelectOne).hide();
    $(usShippingField).removeClass('ui-state-error');

    if (!(isShippingEnabled() || isLocalPickupEnabled())) {
      $(shippingErrorMissingRate).hide(); // If no shipping options are selected, we don't need to require US rate
      $(shippingErrorSelectOne).fadeIn();
      valid = false;
    }

    return valid;
  }

  function init() {
    handleShippingSelect();
    bindShippingRateChange();
    setShippingOnLoad();
  }

  return {
    init: init
  };
})();

$(document).ready(function () {
  Reverb.Listing.ShippingValidation.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/shipping_validation.js